import React from 'react';
import { Grid } from '@mui/material';
import FormInput from '../../../inputs/FormInput';

const GeneralTab = ({
    activeLang,
    nameAr,
    setNameAr,
    nameEn,
    setNameEn,
    slug,
    setSlug,
    sku,
    setSku,
    productType,
    setProductType,
    status,
    setStatus,
    hasVariants,
    setHasVariants,
    shortDescriptionAr,
    setShortDescriptionAr,
    shortDescriptionEn,
    setShortDescriptionEn,
    descriptionAr,
    setDescriptionAr,
    descriptionEn,
    setDescriptionEn,
    isEdit,
    isArabic
}) => {
    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
                {activeLang === 'ar' ? (
                    <FormInput
                        label="الاسم (عربي)"
                        value={nameAr}
                        onChange={(e) => setNameAr(e.target.value)}
                        required
                    />
                ) : (
                    <FormInput
                        label="Name (English)"
                        value={nameEn}
                        onChange={(e) => setNameEn(e.target.value)}
                        required
                    />
                )}
            </Grid>
            <Grid item xs={12} md={6}>
                <FormInput
                    label={isArabic ? 'الرابط (Slug)' : 'Slug'}
                    value={slug}
                    onChange={(e) => setSlug(e.target.value)}
                    disabled={isEdit}
                    required
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <FormInput
                    label={isArabic ? 'رمز التخزين (SKU)' : 'SKU'}
                    value={sku}
                    onChange={(e) => setSku(e.target.value)}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <FormInput
                    label={isArabic ? 'نوع المنتج' : 'Product Type'}
                    type="select"
                    value={productType}
                    onChange={(e) => setProductType(e.target.value)}
                    options={[
                        { id: 'physical', name: { en: 'Physical', ar: 'مادي' } },
                        { id: 'digital', name: { en: 'Digital', ar: 'رقمي' } },
                        { id: 'service', name: { en: 'Service', ar: 'خدمة' } },
                    ]}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <FormInput
                    label={isArabic ? 'الحالة' : 'Status'}
                    type="select"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    options={[
                        { id: 'draft', name: { en: 'Draft', ar: 'مسودة' } },
                        { id: 'active', name: { en: 'Active', ar: 'نشط' } },
                        { id: 'archived', name: { en: 'Archived', ar: 'مؤرشف' } },
                    ]}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <FormInput
                    label={isArabic ? 'يحتوي على متغيرات؟' : 'Has Variants?'}
                    type="switch"
                    checked={hasVariants}
                    onChange={(e) => setHasVariants(e.target.checked)}
                />
            </Grid>
            <Grid item xs={12}>
                {activeLang === 'ar' ? (
                    <FormInput
                        label="وصف قصير (عربي)"
                        type="textarea"
                        rows={2}
                        value={shortDescriptionAr}
                        onChange={(e) => setShortDescriptionAr(e.target.value)}
                    />
                ) : (
                    <FormInput
                        label="Short Description (English)"
                        type="textarea"
                        rows={2}
                        value={shortDescriptionEn}
                        onChange={(e) => setShortDescriptionEn(e.target.value)}
                    />
                )}
            </Grid>
            <Grid item xs={12}>
                {activeLang === 'ar' ? (
                    <FormInput
                        label="الوصف الكامل (عربي)"
                        type="textarea"
                        rows={5}
                        value={descriptionAr}
                        onChange={(e) => setDescriptionAr(e.target.value)}
                    />
                ) : (
                    <FormInput
                        label="Full Description (English)"
                        type="textarea"
                        rows={5}
                        value={descriptionEn}
                        onChange={(e) => setDescriptionEn(e.target.value)}
                    />
                )}
            </Grid>
        </Grid>
    );
};

export default GeneralTab;
